(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stodusyn-lead-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (root.dataset.bbReady) return;
      const form=root.querySelector('form');
      if (!form || !root.querySelector('[data-bb-step]')) return;
      root.dataset.bbReady='true';
      const steps=[...root.querySelectorAll('[data-bb-step]')];
      const existing=root.querySelector('[data-bb-existing-fields]');
      const otherFields=root.querySelector('[data-bb-other-fields]');
      let current=1;
      function toggleContainer(el,visible) { el.hidden=!visible; el.querySelectorAll('input,select,textarea').forEach(input=>input.disabled=!visible); }
      function sync() {
        const yes=Boolean(root.querySelector('[data-bb-existing="yes"]:checked'));
        toggleContainer(existing,yes);
        toggleContainer(otherFields,yes&&root.querySelector('[data-bb-other]').checked);
        root.querySelector('[data-bb-unifi-note]').hidden=!(yes&&root.querySelector('[data-bb-unifi]').checked);
        const selected=[...existing.querySelectorAll('input[type=checkbox]:checked')].map(i=>i.closest('label').textContent.trim());
        root.querySelector('[data-bb-summary]').textContent=yes?'Núverandi myndavélar'+(selected.length?' · '+selected.join(', '):''):'Nýtt myndavélakerfi';
      }
      function show(step,focus) {
        current=step;
        steps.forEach(el=>el.hidden=Number(el.dataset.bbStep)!==step);
        root.querySelectorAll('[data-bb-indicator]').forEach(el=>{const active=Number(el.dataset.bbIndicator)===step;el.classList.toggle('is-active',active);if(active)el.setAttribute('aria-current','step');else el.removeAttribute('aria-current');});
        if(focus){const target=steps[step-1].querySelector('input:not([type=hidden]),select,textarea');if(target)target.focus();}
      }
      root.querySelector('[data-bb-next]').hidden=false;
      root.querySelector('[data-bb-back]').hidden=false;
      root.querySelector('[data-bb-next]').addEventListener('click',()=>{
        const invalid=[...steps[0].querySelectorAll('input,select,textarea')].find(i=>!i.disabled&&!i.checkValidity());
        if(invalid){invalid.reportValidity();return;}sync();show(2,true);
      });
      root.querySelector('[data-bb-back]').addEventListener('click',()=>show(1,true));
      form.addEventListener('change',sync);
      form.addEventListener('keydown',event=>{if(current===1&&event.key==='Enter'&&event.target.tagName!=='TEXTAREA'){event.preventDefault();root.querySelector('[data-bb-next]').click();}});
      form.addEventListener('invalid',event=>{const parent=event.target.closest('[data-bb-step]');if(parent&&parent.hidden)show(Number(parent.dataset.bbStep),false);},true);
      const params=new URLSearchParams(window.location.search);
      const campaign=params.get('utm_campaign');
      if(campaign)root.querySelector('[data-bb-source]').value='Fyrirspurnarform Stöðusýnar · '+campaign.slice(0,150);
      sync();show(root.querySelector('[data-bb-errors]')?2:1,false);
    }
    document.querySelectorAll('[data-bb-lead]').forEach(init);
    document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-bb-lead]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
